import AnagramSolver from "../components/AnagramSolver";

export default function AnagramSolverPage() {
  return <AnagramSolver />;
}
